export default "__VITE_ASSET__BcM7vSOo__"